/**
 * Einstiegspunkt der Oberflaeche.
 */

import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { App } from "./App.jsx";
import { abfragenAnlegen } from "./api/abfragen.js";
import { darstellungAnwenden } from "./api/einstellungen.js";
import { dienstRegistrieren } from "./pwa/dienst.js";
import "./stil.css";

const abfragen = abfragenAnlegen();

// Vor dem ersten Zeichnen -- sonst blitzt die Seite nachts erst hell auf.
darstellungAnwenden();

// Die App fuer den naechsten Start ohne Netz vorhalten (Stufe 3).
dienstRegistrieren();

const wurzel = document.getElementById("wurzel");
if (wurzel === null) throw new Error("Das Wurzelelement fehlt");

createRoot(wurzel).render(
  <StrictMode>
    <QueryClientProvider client={abfragen}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
